import { zodResolver } from '@hookform/resolvers/zod';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Box, Button, CardContent, Chip, FormControl, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { z } from 'zod';
import showToast from '../../../../../components/Hot-Toast/showToast';
import { previousStep, update } from '../../../../../slice/multiStepSlice';
import { useTMutation } from '../../../../../utils/useTMutation';
import { useTQuery } from '../../../../../utils/useTQuery';


export const specialtySchema = z.object({
    SPECIALTY_IDS: z.array(z.string()).min(1, { message: "At least one specialty must be selected" }),
});

const MapJobRoleToSpecialties = () => {
    const dispatch = useDispatch()
    const { values } = useSelector((state) => state?.multiStep);
    console.log("values MapJobRoleToSpecialties", values);

    const [specialties, setSpecialties] = useState([]);
    const [selectedSpecialties, setSelectedSpecialties] = useState([]);

    const { data: specialtiesData } = useTQuery(
        "specialties",
        "/fetchSpecialties",
        'get'
    );


    useEffect(() => {
        if (specialtiesData?.STATUS) {
            setSpecialties(specialtiesData.OUTPUT || []);
        }
    }, [specialtiesData]);

    useEffect(() => {
        if (values.SPECIALTY_IDS) setSelectedSpecialties(values.SPECIALTY_IDS);
    }, [values])

    const {
        control,
        handleSubmit,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(specialtySchema),
        defaultValues: { SPECIALTY_IDS: values.SPECIALTY_IDS || [] },
    });

    const { mutateAsync } = useTMutation("/addUpdateJobRole", "post", (response) => {
        return response

    });

    console.log("values.SPECIALTY_IDS", values)
    const submitJobRole = async (formData) => {
        try {
            const response = await mutateAsync({
                ...formData,
                ID: values?.ID,
            });
            if (response.STATUS) {
                dispatch(update({ SPECIALTY_IDS: formData?.SPECIALTY_IDS }))
                showToast("success", response.MESSAGE, 3000);
                dispatch(previousStep())
            } else {
                showToast("error", response.MESSAGE, 3000);
            }
        } catch (error) {
            console.error("Add Request failed:", error);
            showToast("error", "Something went wrong, Please try again", 3000);
        }
    };

    const handleChipDelete = (specialtyId) => {
        setSelectedSpecialties((prev) => prev.filter(id => id !== specialtyId));
        setValue('SPECIALTY_IDS', selectedSpecialties.filter(id => id !== specialtyId));
        clearErrors('SPECIALTY_IDS');
    };

    const handleSpecialtyChange = (event) => {
        const selectedSpecialtyId = event.target.value;
        if (selectedSpecialtyId && !selectedSpecialties.includes(selectedSpecialtyId)) {
            const updatedSpecialties = [...selectedSpecialties, selectedSpecialtyId];
            setSelectedSpecialties(updatedSpecialties);
            setValue('SPECIALTY_IDS', updatedSpecialties);
        }
        errors.SPECIALTY_IDS = false;

    };

    return (

        <>
            {!values.REDIRECT && <Button
                onClick={() => dispatch(previousStep())}
                startIcon={<ArrowBackIosIcon sx={{ fontSize: "12px", color: "#000000" }} />}
                sx={{ textTransform: 'none', fontWeight: 500, fontSize: "14px", padding: 3, minWidth: 0 }}
            >
            </Button>}
            <Grid lg={12}>
                <CardContent>
                    <Typography variant="h2" component="div" mb={1} mt={-3} fontWeight="bold">
                        Assign specialties
                    </Typography>
                    <form onSubmit={handleSubmit(submitJobRole)}>
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                            <FormControl fullWidth margin="normal">
                                <Controller
                                    name="SPECIALTY_IDS"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            select
                                            label="Select"
                                            value=""
                                            onChange={handleSpecialtyChange}
                                            error={!!errors.SPECIALTY_IDS}
                                            helperText={errors.SPECIALTY_IDS?.message}
                                        >
                                            <MenuItem disabled value="">Select</MenuItem>
                                            {specialties.map((specialty) => (
                                                <MenuItem key={specialty.ID} value={specialty.ID}>
                                                    {specialty.SPECIALTY_NAME}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    )}
                                />
                                {/* {errors.SPECIALTY_IDS && <Typography color="error">{errors.SPECIALTY_IDS.message}</Typography>} */}
                            </FormControl>

                            <Box sx={{ mt: 2 }}>
                                <Grid container spacing={1}>
                                    {selectedSpecialties.map((specialtyId) => (
                                        <Grid item xs={4} key={specialtyId}>
                                            <Chip
                                                label={specialties.find(role => role.ID === specialtyId)?.SPECIALTY_NAME}
                                                onDelete={() => handleChipDelete(specialtyId)}
                                                sx={{ borderRadius: 0.9 }}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end',marginTop:-3}}>
                                <Button variant="contained" className='custombuttons' type='submit'>
                                    Add
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </CardContent>
            </Grid>



        </>
    );
};

export default memo(MapJobRoleToSpecialties);
